import Vue from 'vue'
import Moment from "moment"
import {
	EventBus
} from '@/utils/event-bus';

class Helper {
	static jkrRoles = ["JKR", "JKR District"]

	static truncateText = (text) => {
		if (!text || text.length <= 100) return text

		return text.slice(0, 90).concat("...")
	}

	static currentYear = new Date().getFullYear()

	static filterYears = [this.currentYear, this.currentYear - 1, this.currentYear - 2]

	static caseProgressStatuses = [
		{ text: "Preliminery Work & Mobilization", value: 15 },
		{ text: "25% Crusher Run / Pavement Completed", value: 50 },
		{ text: "75% Pavement Completed", value: 75 },
		{ text: "100% Pavement Completed", value: 90 },
		{ text: "Coring Test Completed / Road Line in Progress", value: 95 },
		{ text: "Completed", value: 100 },
	]

	static caseProgressColor = (progress) => {
		if (!progress) {
			return "secondary"
		} else if (progress < 100) {
			return "warning"
		} else {
			return "success"
		}
	}

	static pavementRoadOwners = (pavement) => {
		const ownerArray = pavement?.iraa_road?.map(function (item) {
			return item.attributes["owner"];
		});

		if (!ownerArray.length) return "Owner not set";

		const result = [];

		ownerArray.forEach(owner => {
			if (!result.find(r => r == owner)) {
				result.push(owner)
			}
		});

		return result.join(", ");
	}

	static pavementRoadNames = (pavement, opts) => {
		const roadArray = pavement?.iraa_road?.map(function (item) {
			return `${opts?.includeOwner ? "(" + item.attributes["owner"] + ") " : ""}${item.attributes["name"]}`;
		});

		if (!roadArray || !roadArray.length) return "Road not set";

		if (opts?.showAll || roadArray.length <= 2) {
			return roadArray.join(", ");
		} else {
			return roadArray
				.slice(0, 2)
				.join(", ")
				.concat(
					`<span class="badge">+${roadArray.length - 2
					} more</span>`
				);
		}
	}

	static inputStatusClass = (value) => {
		if (!value) {
			return "bg-white text-dark";
		} else {
			return "bg-gray-500 text-black";
		}
	}
	static inputClass = (currentStatus, nodStatus) => {
		if (nodStatus == currentStatus) {
			return "bg-white text-dark";
		} else {
			return "bg-gray-500 text-black";
		}
	}

	static kebabToPascalCase = (text, withSpace) => {
		if (!text) return "";

		const textSplit = text.split("-");

		const capitalizedTextSPlit = textSplit.map(txt => {
			return txt[0].toUpperCase() + txt.substring(1);
		});

		return capitalizedTextSPlit.join(withSpace ? " " : "");
	}

	static getCaseAddress = (nod) => {
		if (!nod) return null;

		let result = [];

		if (nod.district) {
			result.push(nod.district.name);
		}

		if (nod.road) {
			result.push(nod.road.name);
		}

		return result.join(", ");
	}

	static getCaseImage = (mediaArray) => {
		if (mediaArray && mediaArray.length > 0) {
			return this.formatMediaUrl(mediaArray[mediaArray.length - 1]);
		} else {
			return null;
		}
	}

	static allCaseStatuses = {
		default: [
			"site_visit",
			"bq",
			"jkr_wo",
			"wo",
			"site_diary",
			"payment"
		],
		others: ["site_visit", "bq", "memo"]
	}

	static toggleLoadingSpinner = (e) => {
		EventBus.$emit('toggleLoadingSpinner', e);
	}

	static userInitial = (user) => {
		if (user) {
			let user_name = user.name;

			if (!user_name) return "ME";

			let result = "";

			user_name.replace(/[^a-zA-Z0-9_]+/g, " ").split(" ").forEach(name => {
				result += name.split("")[0];
			});

			return result.slice(0, 2);
		} else {
			return "";
		}
	}

	static removeDuplicates(array) {
		return array.filter((value, index, self) => {
			return self.indexOf(value) === index;
		})
	}

	static moment = (args) => {
		return Moment(args);
	}

	static formatDate = (date, withTime) => {
		if (!date) {
			return ""
		} else if (withTime) {
			return this.moment(date).format("D MMM YYYY, h:mm A")
		} else {
			return this.moment(date).format("D MMM YYYY")
		}
	}

	static formatMoney = (data) => {
		if (!data) {
			return "RM 0.00"
		} else {
			return data.toLocaleString("en-MY", { style: "currency", currency: "MYR" });
		}
	}

	static formatMediaUrl = (media) => {
		if (media && media.url) {
			let url = media.url

			return url.startsWith("http") ? url : `https://${url}`
		} else {
			return false
		}
	}

	static formatCoordinate = (coord) => {
		if (coord && typeof coord == "object" && coord.length == 2) {
			return `${parseFloat(coord[0]).toFixed(6)}, ${parseFloat(coord[1]).toFixed(6)}`
		}
		if (coord && !isNaN(coord)) {
			return `${parseFloat(coord).toFixed(6)}`
		} else {
			return ""
		}
	}

	static formatAddress = (address, city, state) => {
		let result = []

		if (address) {
			result.push(address)
		}

		if (city) {
			result.push(city)
		}

		if (state) {
			result.push(state)
		}

		return result.join(", ")
	}

	static validateEmail = (email) => {
		let pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);

		if (!pattern.test(email)) {
			return false;
		}

		return true;
	}

	static validatePassword = (password) => {
		// Minimum 7 characters, must include uppercase, lowercase, number and a symbol.
		let pattern = new RegExp(/^(?=.*[\W_])(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{7,}$/);

		if (!pattern.test(password)) {
			return false;
		}

		return true;
	}

	static validateToken = () => {
		const token = localStorage.getItem("token");

		if (!token) {
			localStorage.removeItem("token");

			return false;
		}

		let tokenSplit = token.split(".");

		if (tokenSplit.length != 3) {
			localStorage.removeItem("token");

			return false;
		} else {
			let decodedHeader = Buffer.from(tokenSplit[0], "base64");

			if (decodedHeader && JSON.parse(decodedHeader.toString()).typ == "JWT") {
				return true;
			} else {
				localStorage.removeItem("token");

				return false;
			}
		}
	}

	static handlePromise = (promise) => {
		return promise
			.then(data => ([data, undefined]))
			.catch(error => Promise.resolve([undefined, error]));
	}

	static deriveMediaFilename = (url) => {
		if (!url) return `download-${Date.now()}`

		if (url.startsWith("data:")) {
			const match = url.match(/^data:([^;]+);/)
			const ext = match ? (match[1].split("/")[1] || "bin") : "bin"
			return `image-${Date.now()}.${ext}`
		}

		try {
			const path = new URL(url).pathname
			const last = path.split("/").pop()
			if (last) return decodeURIComponent(last)
		} catch (e) {
			// fall through
		}

		return `download-${Date.now()}`
	}

	static _toastContainer = null
	static _toastDuration = 5000

	static _ensureToastContainer = () => {
		if (Helper._toastContainer && document.body.contains(Helper._toastContainer)) {
			return Helper._toastContainer
		}
		const c = document.createElement("div")
		c.className = "app-toast-stack"
		document.body.appendChild(c)
		Helper._toastContainer = c
		return c
	}

	static _showToast = (variant, message) => {
		const container = Helper._ensureToastContainer()
		const toast = document.createElement("div")
		toast.className = `app-toast app-toast-${variant}`

		const iconClass = variant === "success" ? "fa-circle-check" : "fa-circle-info"

		toast.innerHTML = `
			<i class="fa-solid ${iconClass} app-toast-icon"></i>
			<span class="app-toast-message"></span>
			<button type="button" class="app-toast-close" aria-label="Close">
				<i class="fa-solid fa-xmark"></i>
			</button>
			<div class="app-toast-progress"></div>
		`
		toast.querySelector(".app-toast-message").textContent = message

		container.appendChild(toast)

		let dismissed = false
		const dismiss = () => {
			if (dismissed) return
			dismissed = true
			toast.classList.add("app-toast-leaving")
			setTimeout(() => toast.remove(), 250)
		}

		const timer = setTimeout(dismiss, Helper._toastDuration)
		toast.querySelector(".app-toast-close").addEventListener("click", () => {
			clearTimeout(timer)
			dismiss()
		})
	}

	static successToast = (message) => {
		Helper._showToast("success", message)
	}

	static removeToast = (message) => {
		Helper._showToast("info", message)
	}

	static downloadMedia = async (url) => {
		if (!url) return

		const filename = Helper.deriveMediaFilename(url)

		const triggerDownload = (href) => {
			const a = document.createElement("a")
			a.href = href
			a.download = filename
			document.body.appendChild(a)
			a.click()
			document.body.removeChild(a)
		}

		if (url.startsWith("data:")) {
			triggerDownload(url)
			return
		}

		try {
			const res = await Vue.API.getExternal(url, "file")
			const blobUrl = URL.createObjectURL(res.data)
			triggerDownload(blobUrl)
			URL.revokeObjectURL(blobUrl)
		} catch (err) {
			console.error("download failed, opening in new tab", err)
			window.open(url, "_blank")
		}
	}
}

export default {
	currentYear: Helper.currentYear,
	jkrRoles: Helper.jkrRoles,
	install: () => {
		Vue.prototype.Helper = Helper
		Vue.Helper = Helper
	}
}